import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'redux-zero/react';

import { actions } from '../../shared/store.js';
import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import CareersDetailService from './careers.service.js';
import { Button } from '../../components/ui-toolkit/buttons.js';
import ScrollToTop from '../../shared/utils.js';
import Seo from '../../infrastructure/seo.js';

import './job-details.scss';

class CareersDetailsPage extends Component {
	static prefetchData = async (language, id) => CareersDetailService.fetchCareersDetailsById(language, id);

	state = {
		hasError: false,
	};

	componentDidMount() {
		const { careersDetail, match, setLoading } = this.props;

		ScrollToTop();
		if (!careersDetail || careersDetail.slug !== match.params.slug) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const { language, match } = this.props;

		ScrollToTop();
		if (
			language.value !== prevProps.language.value
			|| match.params.slug !== prevProps.match.params.slug
		) {
			this.fetchData();
		}
	}

	fetchData() {
		const {
			setLoading, language, match, setCareersDetail,
		} = this.props;

		setLoading(true);
		CareersDetailsPage.prefetchData(language.value, match.params.slug)
			.then((data) => {
				setCareersDetail(data);
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				this.setState({
					hasError: true,
				});
				console.log(error);
			});
	}

	render() {
		const { match, careersDetail, intl: { formatMessage }, addresses, phones, generalData } = this.props;
		const { hasError } = this.state;
		const careerId = match.params.slug;

		const regex = /(<([^>]+)>)/ig;

		if (hasError || !careersDetail) {
			return <NotImplemented title="Careers Detail" />;
		}

		const {
			jobDescription,
			primaryResponsabilities,
			requirements,
			personalAttributes,
			additionalBeneficialExperience,
			thePosition,
		} = careersDetail;

		return (
			<div className="outside">
				<Seo
					title={(careersDetail && careersDetail.title) || formatMessage({ id: 'careers.career' })}
					description={jobDescription.replace(regex, '') || formatMessage({ id: 'careers.career' })}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "JobPosting",
											"title": "${careersDetail && careersDetail.title}",
											"description": "${jobDescription.replace(regex, '') || ''}",
											"hiringOrganization": {
												"@type": "Organization",
												"name": "Inocrowd"
											}
										},
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.careers' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/careers"
												},
												{
													"@type": "ListItem",
													"name": "${(careersDetail && careersDetail.title) || formatMessage({ id: 'navigation.careers' })}",
													"position": 3,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/careers/${careersDetail.id}"
												}
											]
										}
									]
								}`}
				/>
				<div className="career-detail-section">
					<div className="container container-fluid">
						<div className="section job-title">
							<span>{careersDetail.title}</span>
						</div>
						<div className="specifications">
							<div className="section job-description">
								<div className="title">
									{formatMessage({ id: 'careers.job-description' })}
								</div>
								<div
									className="description"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{ __html: jobDescription }}
								/>
							</div>
							<div className="section responsibilities">
								<div className="title">
									{formatMessage({ id: 'careers.primaryResponsibilities' })}
								</div>
								<div
									className="description"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{ __html: primaryResponsabilities }}
								/>
							</div>
							<div className="section">
								<div className="title">
									{formatMessage({ id: 'careers.requirements' })}
								</div>
								<div
									className="description"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{ __html: requirements }}
								/>
							</div>
							<div className="section">
								<div className="title">
									{formatMessage({ id: 'careers.personalAttributes' })}
								</div>
								<div
									className="description"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{ __html: personalAttributes }}
								/>
							</div>
							<div className="section">
								<div className="title">
									{formatMessage({
										id: 'careers.aditionalBeneficialExperience',
									})}
								</div>
								<div
									className="description"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{
										__html: additionalBeneficialExperience,
									}}
								/>
							</div>
							<div className="section">
								<div className="title">
									{formatMessage({ id: 'careers.thePosition' })}
								</div>
								<div
									className="description"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{ __html: thePosition }}
								/>
							</div>
						</div>

						<div className="section button-apply-now">
							<Button
								className="btn-color-theme-2"
								to={`/careers/${careerId}/apply`}
							>
								{formatMessage({ id: 'careers.button' })}
							</Button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapToProps = ({ language, careersDetail, addresses, phones, generalData }) => ({
	language,
	careersDetail,
	addresses,
	phones,
	generalData
});
export default connect(
	mapToProps,
	actions,
)(injectIntl(CareersDetailsPage));

export { CareersDetailsPage };
